import React, { useEffect, useState } from 'react';
import { Spinner, Button } from '../../shim/reactstrap';
import { Link } from 'react-router-dom';
import ApiClient from '../../api/ApiClient';

export const AdminPackageTickersStatus = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tickers, setTickers] = useState([]);

  useEffect(() => {
    let mounted = true;

    async function load() {
      setLoading(true);
      setError(null);
      try {
        const items = await ApiClient.getPackageTickers();
        if (!mounted) return;
        setTickers(items || []);
      } catch (err) {
        console.error('Failed to load package tickers', err);
        if (mounted) setError(err.message || 'Failed to load tickers');
      } finally {
        if (mounted) setLoading(false);
      }
    }

    load();
    return () => { mounted = false; };
  }, []);

  function renderTable() {
    if (loading) return (
      <div className="text-center py-5"><Spinner /></div>
    );
    if (error) return <div className="alert alert-danger">{error}</div>;
    if (!tickers || tickers.length === 0) return <p>No package tickers found.</p>;

    return (
      <table className="table table-striped">
        <thead>
          <tr>
            <th>Id</th>
            <th>Ticker source</th>
            <th>Subfolder</th>
            <th>Code</th>
            <th>Name</th>
            <th>Latest available candle</th>
            <th style={{ width: '140px' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {tickers.map((t) => {
            const latestCandle = t.LatestCandle || null;
            const latestDisplay = latestCandle ? latestCandle.getTime() : null;
            const unixSeconds = latestCandle && typeof latestCandle.getUnixSeconds === 'function'
              ? latestCandle.getUnixSeconds()
              : null;
            const isStale = unixSeconds && (Date.now() - unixSeconds * 1000 > 3 * 24 * 60 * 60 * 1000);
            const isoTooltip = latestCandle && latestCandle.Time && typeof latestCandle.Time.toISOString === 'function'
              ? latestCandle.Time.toISOString()
              : null;

            const isMissing = !latestCandle;
            // PackageTickersStatus returns TickerId (the underlying Ticker Id)
            // and PackageTickerId (the PackageTicker row Id). The analyze endpoint
            // takes the PackageTicker row Id, so prefer that when present.
            const packageTickerId = t.PackageTickerId ?? t.Id;
            return (
              <tr key={t.Id} className={isMissing ? 'table-danger' : (isStale ? 'table-warning' : '')}>
                <td>{t.Id}</td>
                <td>{t.Source}</td>
                <td>{t.Subfolder}</td>
                <td>{t.Code}</td>
                <td>{t.Name}</td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  {latestDisplay || '-'}
                  {isMissing && (
                    <span title="No latest candle available" style={{ color: 'darkred', marginLeft: 8 }}>
                      ✖
                    </span>
                  )}
                  {(!isMissing && isStale) && (
                    <span title={isoTooltip ? `Latest candle: ${isoTooltip}` : 'Latest candle is stale'} style={{ color: 'red', marginLeft: 8 }}>
                      ⚠️
                    </span>
                  )}
                </td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  <Link to={`/admin/package-tickers/${packageTickerId}/analyze`}>
                    <Button color="primary" size="sm">Analyze</Button>
                  </Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Package Tickers status</h2>
      </div>

      {renderTable()}
    </div>
  );
};
